import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language;
  },
};

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language);
  },
};

export default new Vuex.Store({
  state: {
    // ios 需要下载的链接
    iosUrl:
      'https://apps.apple.com/app/apple-store/id1470928669?pt=120227142&ct=totok_website&mt=8',
    // android需要下载的链接
    // AndroidUrl:
    //   "https://play.google.com/store/apps/details?id=ai.totok.chat&referrer=utm_source%3Dtotok%26utm_medium%3Dwebsite",
    AndroidUrl:
      'https://static2.totok.ai/android/totok-pub-release_v1.9.13(453)_totok.apk',
    // apkurl
    apkurl:
      'https://static2.totok.ai/android/totok-pub-release_v1.9.13(453)_totok.apk',
    // 点击邮箱需要跳转的链接
    supportUrl: 'mailto:help@totok.ai',
    // 当前语言
    language: 'en',
  },
  mutations,
  actions,
});
